import { useUnstakeDialog } from './logic/useUnstakeDialog'
import { SuccessView } from './views/SuccessView'
import { UnstakeView } from './views/UnstakeView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface StakeContainerProps {
  closeDialog: () => void
}

function UnstakeDialogContentContainer({ closeDialog }: StakeContainerProps) {
  const {
    selectableAssets,
    assetsFields,
    form,
    outcomeToken,
    pageStatus,
    txOverview,
    exitFarmSwitchInfo,
    actionsViewState,
  } = useUnstakeDialog()

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        outcome={outcomeToken}
        reward={exitFarmSwitchInfo.reward}
        closeDialog={closeDialog}
        isExiting={exitFarmSwitchInfo.checked}
      />
    )
  }

  return (
    <UnstakeView
      form={form}
      selectableAssets={selectableAssets}
      assetsFields={assetsFields}
      txOverview={txOverview}
      exitFarmSwitchInfo={exitFarmSwitchInfo}
      actionsViewState={actionsViewState}
    />
  )
}

const UnstakeDialogContentContainerWithSuspense = withSuspense(UnstakeDialogContentContainer, DialogContentSkeleton)
export { UnstakeDialogContentContainerWithSuspense as UnstakeDialogContentContainer }
